import { Group, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { OsLotReviewListItem } from '../../lib/types/os-lot-reviews';

import classes from './os-lot-reviews.module.css';

export function OsLotReviewIndicatorBadges({
  lot,
}: {
  lot: Pick<OsLotReviewListItem, 'yield_ok' | 'tonnage_ok' | 'area_ok'>;
}) {
  const { t } = useTranslation();

  const fails = [
    !lot.yield_ok
      ? { key: 'yield', label: t('osLotReviews.indicators.yield') }
      : null,
    !lot.tonnage_ok
      ? { key: 'tonnage', label: t('osLotReviews.indicators.tonnage') }
      : null,
    !lot.area_ok
      ? { key: 'area', label: t('osLotReviews.indicators.area') }
      : null,
  ].filter((item): item is { key: string; label: string } => item != null);

  if (fails.length === 0) {
    return (
      <Text c="pf-green.8" fw={600} size="sm">
        {t('osLotReviews.indicators.ok')}
      </Text>
    );
  }

  const failLabel = t('osLotReviews.indicators.fail');

  return (
    <Group gap={6} wrap="wrap">
      {fails.map((item) => (
        <span className={classes.failChip} key={item.key}>
          {item.label} {failLabel}
        </span>
      ))}
    </Group>
  );
}
